<template>
    <div>
        <b-row>
            <b-col cols="12">
                <b-card class="mb-3" title="İlginizi Çekebilir">
                    <b-alert variant="warning" show class="mb-0">
                        <div class="alert-body mb-2">
                            <span><strong>Not:</strong>Anasayfada görüntülenecek 2 adet içerik seçin...</span>
                        </div>
                    </b-alert>
                </b-card>
            </b-col>
        </b-row>
        <validation-observer ref="rules">
            <b-row>
                <b-col cols="12">
                    <b-card class="mb-3" title="İlginizi Çekebilir">
                        <b-row>
                            <b-col cols="12">
                                <b-form-group label="Kategori" label-for="category">
                                    <validation-provider #default="{ errors }" :rules="{
                                        required: true
                                    }" name="Kategori">
                                        <v-select id="category" v-model="selectedCategory" label="name"
                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="categories" />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12">
                                <b-form-group label="İçerik" label-for="content">
                                    <validation-provider #default="{ errors }" :rules="{
                                        required: true
                                    }" name="İçerik">
                                        <v-select id="content" v-model="selectedContent" label="title"
                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="contents" />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12">
                                <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-primary"
                                    @click="postConfirmText(true, false)">
                                    <b-spinner v-if="spinner == true" small />
                                    {{ spinner == true ? "Ekleniyor" : "Ekle" }}
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <b-card class="mb-3" title="İçerik Listesi">
                        <table class="table b-table">
                            <thead>
                                <th>#</th>
                                <th>İÇERİK ADI</th>
                                <th>SİL</th>
                            </thead>
                            <draggable v-if="sliders.length > 0" v-model="sliders" class="cursor-move" tag="tbody"
                                @change="outputData">
                                <tr v-for="slider in sliders" :key="slider.id">
                                    <td>{{ slider.id }}</td>
                                    <td>{{ slider.content.title }}</td>
                                    <td>
                                        <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-danger"
                                            class="btn-icon rounded-circle" @click="deleteConfirmText(slider.id)">
                                            <feather-icon icon="TrashIcon" />
                                        </b-button>
                                    </td>
                                </tr>
                            </draggable>
                            <thead>
                                <th>#</th>
                                <th>İÇERİK ADI</th>
                                <th>SİL</th>
                            </thead>
                        </table>
                    </b-card>
                </b-col>
            </b-row>
        </validation-observer>
    </div>
</template>
<script>
import draggable from "vuedraggable";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
    BImg,
    BRow,
    BCol,
    BTime,
    BCard,
    BCardText,
    BButton,
    BForm,
    BMedia,
    BAlert,
    BSpinner,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BFormTextarea,
    BMediaAside,
    BMediaBody,
    BFormFile,
    BFormDatepicker,
    BLink,
} from "bootstrap-vue";
import {
    required,
    email,
    confirmed,
    url,
    between,
    alpha,
    integer,
    password,
    min,
    digits,
    alphaDash,
    length,
} from "@validations";

import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();

export default {
    components: {
        BImg,
        BRow,
        BCol,
        BTime,
        BLink,
        BCard,
        BCardText,
        BButton,
        BForm,
        BSpinner,
        BAlert,
        BFormGroup,
        BFormInput,
        BInputGroup,
        BFormTextarea,
        BMedia,
        BMediaAside,
        BMediaBody,
        BFormFile,
        BFormDatepicker,
        vSelect,
        ValidationProvider,
        ValidationObserver,
        required,
        email,
        confirmed,
        url,
        between,
        alpha,
        integer,
        password,
        min,
        digits,
        alphaDash,
        length,
        draggable

    },
    directives: {
        Ripple,
    },
    data() {
        return {
            spinner: false,
            request:[],
            sliders: [],
            contents: [],
            categories: [],
            selectedContent: null,
            selectedCategory: null
        };
    },
    watch: {
        selectedCategory(newSelectedCategory, oldSelectedCategory) {
            this.getContentsByCategorySlug(newSelectedCategory.slug)
        }
    },
    methods: {
        outputData() {
            this.updateSubmit()
        },
        updateSubmit() {
            this.request = []
            Object.entries(this.sliders).forEach(([key, value]) => {
                let sliderOrder = {
                    id: value.id,
                    order: parseInt(key),
                };
                this.request.push(sliderOrder);
            });
            endpoints
                .putSettingsSliderHighlightsOrder({ sliders: this.request }, this.$i18n.locale, () => { })
                .then((data) => {
                    this.$swal({
                        icon: "success",
                        title: "Güncelleme başarılı!",
                        text: "Slider sıralaması güncellendi.",
                        customClass: {
                            confirmButton: "btn btn-success",
                        },
                    });
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        getCategories() {
            endpoints
                .getCategories(null, this.$i18n.locale, () => { })
                .then((data) => {
                    this.categories = []
                    this.categories = [...data.response]
                    this.selectedCategory = this.categories[0]
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        getSettingsSliderHighlights() {
            endpoints.
                getSettingsSliderHighlights(null, this.$i18n.locale, () => { })
                .then((data) => {
                    this.sliders = [];
                    this.sliders = [...data.response];
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        getContentsByCategorySlug(slug) {
            endpoints.
                getContentsByCategorySlug(slug, this.$i18n.locale, () => { })
                .then((data) => {
                    this.contents = [];
                    this.contents = [...data.response];
                    this.selectedContent = this.contents[0]
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        postConfirmText() {
            this.$swal({
                title: "Kayıt?",
                text: "Slider listesini kaydetmek istediğinize emin misiniz?",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "Vazgeç!",
                confirmButtonText: "Kaydet!",
                customClass: {
                    confirmButton: "btn btn-primary",
                    cancelButton: "btn btn-outline-danger ml-1",
                },
                buttonsStyling: false,
            }).then((result) => {
                if (result.value) {
                    this.postSubmit();
                }
            });
        },
        postSubmit() {
            if (this.sliders.length > 1) {
                this.$swal({
                    title: 'Hata!',
                    text: '2 adetten fazla içerik seçilemez!',
                    icon: 'error',
                    confirmButtonText: "Tamam",
                    customClass: {
                        confirmButton: 'btn btn-primary',
                    },
                }).then((result) => {
                    if (result.value) {

                    }
                });
            } else {
                this.$refs.rules.validate().then((success) => {
                    if (success) {
                        this.spinner = true;
                        let formData = new FormData();
                        formData.append("contentId", this.selectedContent.id)
                        endpoints
                            .postSettingsSliderHighlights(formData, this.$i18n.locale, () => { })
                            .then((data) => {
                                this.spinner = false;
                                this.$swal({
                                    icon: "success",
                                    title: "Kayıt başarılı!",
                                    text: "Yeni slider eklendi.",
                                    customClass: {
                                        confirmButton: "btn btn-success",
                                    },
                                }).then((result) => {
                                    this.getSettingsSliderHighlights()
                                });
                            })
                            .catch((err) => {
                                this.spinner = false;
                                console.log(err);
                            });
                    }
                });
            }

        },
        deleteConfirmText(id) {
            this.$swal({
                title: "Sil?",
                text: "Slideri silmek istediğinize emin misiniz?",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "Vazgeç!",
                confirmButtonText: "Kaydet!",
                customClass: {
                    confirmButton: "btn btn-primary",
                    cancelButton: "btn btn-outline-danger ml-1",
                },
                buttonsStyling: false,
            }).then((result) => {
                if (result.value) {
                    this.deleteSubmit(id);
                }
            });
        },
        deleteSubmit(id) {
            endpoints
                .deleteSettingsSliderHighlights(id, this.$i18n.locale, () => { })
                .then((data) => {
                    this.getSettingsSliderHighlights()
                    this.$swal({
                        icon: "success",
                        title: "Silme başarılı!",
                        text: "Slider silindi",
                        customClass: {
                            confirmButton: "btn btn-success",
                        },
                    });
                })
                .catch((err) => {
                    console.log(err);
                });
        },

    },
    created() { },
    destroyed() { },
    mounted() {
        this.getCategories()
        this.getSettingsSliderHighlights()
    },
    setup() {
    }
};
</script>
<style lang="css">
.ql-container {
    margin-top: 30px;
}

.ql-container,
.ql-editor {
    min-height: 300px !important;
    margin-bottom: 30px;
}
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/quill.scss";
</style>
<style>
.draggable-card {
    margin-bottom: 0;
}

.draggable-card>.card-body {
    padding: 10px;
}

.draggable-card>.card-body>.card-title {
    margin-bottom: 0;
    font-size: 1rem;
}

.tree-node {
    border: 0 !important;
}
</style>
